export default __webpack_public_path__ + "static/media/box-card3.daf9d198.png";